// Wrapper mínimo sobre localStorage para flags booleanos (p.ej. el estado
// expandido/colapsado de una sección). Falla en silencio si localStorage está
// deshabilitado (modo privado, sandbox de tests): devuelve el fallback en
// lectura y no-op en escritura. Mantiene la misma semántica que tenía
// CollapsibleSection inline, ahora reutilizable por los dueños del estado.
export function readBoolFlag(key, fallback = true) {
    try {
        const saved = localStorage.getItem(key);
        return saved === null ? fallback : saved === "true";
    } catch (e) {
        return fallback;
    }
}

export function writeBoolFlag(key, value) {
    try {
        localStorage.setItem(key, String(value));
    } catch (e) {
        /* noop — localStorage no disponible */
    }
}
